import React from "react";

export const Progress = () => (
  <div>
    <h2>Progress: here is your progress</h2>
  </div>
  );

export default Progress;
